import React from 'react'
import PT from 'prop-types'
import classNames from 'classnames'
import { Location } from '@reach/router'
import { AnchorLink } from 'gatsby-plugin-anchor-links'

import styles from './styles.module.scss'

const menu = [
    {
        text: 'Brand system',
        link: '#brand-system',
    },
    {
        text: 'Color palette',
        link: '#colour-palette',
    },
    {
        text: 'Typography',
        link: '#typograhy',
    },
    {
        text: 'Graphic',
        link: '#graphic',
    },
    {
        text: 'Ui kit',
        link: '#ui-kit',
    },
    {
        text: 'Web solution',
        link: '#web-solution',
    },
    {
        text: 'Office materials',
        link: '#office-materials',
    },
]

const NavBrandIdentity = ({ location, className }) => {
    const classNameNavBrandIdentity = classNames(styles.navBrandIdentity, className)
    const classNameBrandIdentity = classNames(styles.title, styles.hoverMainLink)

    return (
        <div className={classNameNavBrandIdentity}>
            <ul className={styles.navBrand}>
                <li className={classNameBrandIdentity}>
                    <AnchorLink to={`${location.pathname}#brand-identity`}>
                        Brand Identity
                    </AnchorLink>
                </li>
                {menu.map(({ text, link }) => (
                    <li className={styles.navBrandItem} key={text}>
                        <AnchorLink to={location.pathname + link}>{text}</AnchorLink>
                    </li>
                ))}
            </ul>
        </div>
    )
}

const NavBrandIdentityContainer = ({ className }) => (
    <Location>
        {({ location }) => <NavBrandIdentity location={location} className={className} />}
    </Location>
)

export default NavBrandIdentityContainer

NavBrandIdentityContainer.propTypes = {
    className: PT.string,
}

NavBrandIdentity.propTypes = {
    location: PT.object.isRequired,
    className: PT.string,
}
